import React from 'react';
import I18n from 'app/i18n';
import coinDeposit from 'images/bonuses/bonuses-card/coin-deposit.png';

const CENTS_IN_UNIT = 100;
const FRACTION_PAD_LENGTH = 2;

interface PromoMoneyCardProps {
    amount: number;
}

const PromoMoneyCard = ({amount}: PromoMoneyCardProps): React.ReactElement => {
    const whole = Math.trunc(amount);
    const fraction = Math.trunc((amount - whole) * CENTS_IN_UNIT);
    const fractionLabel = String(fraction).padStart(FRACTION_PAD_LENGTH, '0');

    return <div className="bonuses-card bonuses-card--promo-money">
        <div className="bonuses-card-wrapper">
            <div className="bonuses-card__img">
                <img src={coinDeposit} alt={I18n.t('promo_money_label')}/>
            </div>
            <p className="bonuses-card__amount">
                ${whole}
                {fraction > 0 && <span className="bonuses-card__amount-fraction">.{fractionLabel}</span>}
            </p>
            <p className="bonuses-card-time bonuses-card-time__text bonuses-card-time__text--permanent">
                {I18n.t('promo_money_label')}
            </p>
        </div>
    </div>;
};

export default PromoMoneyCard;
